import { Component, Prop, Vue, Watch } from 'nuxt-property-decorator';

import Modal from '../modal/index.vue';
import lazyImage from '../lazyImage/index';
import CustomTooltip from '../tooltips/customTooltip.vue';
import Button from '../button/index.vue';
import Input from '../form/index.vue';
import Tag from '../tag/index.vue';
import videoPlayer from '../videoPlayer/index.vue';

import IconPlay from '../../assets/svg/play.svg';
import IconLeftArrow from '../../assets/svg/chevron-left.svg';
import IconRightArrow from '../../assets/svg/chevron-right.svg';
import IconDownload from '../../assets/svg/download.svg';

@Component<MediaPreview>({
  components: {
    Modal,
    Button,
    Input,
    Tag,
    lazyImage,
    CustomTooltip,
    IconLeftArrow,
    IconRightArrow,
    videoPlayer,
    IconPlay,
  },
  data() {
    return {
      IconDownload,
      mediasPreview: this.$props.medias,
      currentMedia: this.$props.medias[this.$props.selectedMedia] || this.$props.medias[0],
      tooltipOpen: false,
      inputTag: '',
    }
  }
})
export default class MediaPreview extends Vue {
  @Prop({ type: Number })
  selectedMedia!: number;

  @Prop()
  medias!: [{
    id: string;
    tags: [{
      label: string;
      color?: string;
    }];
    thumb: string;
    title?: string;
    media: string | Function;
  }];

  @Prop({ type: Boolean })
  isOpen!: boolean;

  @Prop({ type: String })
  button!: string;

  @Prop()
  recentTags!: [{
    label: string;
    color?: string;
  }];

  @Prop()
  videos!: [];

  isClosable: boolean = false;

  get currentMediaFilename(): string {
    const media = this.$data.currentMedia.media;
    if (typeof media === 'string')
      return media.substring(media.lastIndexOf('/') + 1);
    return ''
  }

  get currentMediaIndex(): number {
    return this.mediaIndex(this.$data.currentMedia);
  }


  get totalMedias(): number {
    return this.$data.mediasPreview.length;
  }

  mediaIndex(index: number): number {
    return this.$data.mediasPreview.indexOf(index);
  }

  displayArrow(position: string): boolean {
    if (position === 'prev') {
      return this.currentMediaIndex !== 0;
    }

    return this.currentMediaIndex !== this.totalMedias - 1;
  }

  keyboardNavigation(e: KeyboardEvent): void {
    if (e.key === 'ArrowLeft' || e.keyCode === 37) {
      if (this.currentMediaIndex - 1 >= 0) {
        this.$data.currentMedia = this.$data.mediasPreview[this.currentMediaIndex - 1];
      }
    }

    if (e.key === 'ArrowRight' || e.keyCode === 39) {
      if (this.currentMediaIndex + 1 <= this.totalMedias - 1) {
        this.$data.currentMedia = this.$data.mediasPreview[this.currentMediaIndex + 1];
      }
    }
  }

  updateCurrentMedia(e: Event, index: number): void {
    e.preventDefault();

    this.$data.currentMedia = this.$data.mediasPreview[index];
  }

  async manageTooltip(e: Event): Promise<void> {
    this.$data.tooltipOpen = !this.$data.tooltipOpen;
    if (!this.$data.tooltipOpen) {
      this.isClosable = false;
    }
    else {
      await new Promise(resolve => setTimeout(resolve, 100));
      this.isClosable = true;
    }
  }

  onClickOutside(e: Event): void {
    if (this.isClosable) {
      this.manageTooltip(e);
    }
  }

  addTag(e: Event, tag: Tag): void {
    e.preventDefault();
    const media = this.$data.currentMedia;

    if (tag) {
      media.tags.push(tag);
    } else {
      const tag = {
        label: this.$data.inputTag,
        color: '',
      }
      media.tags.push(tag);
    }

    this.$data.inpuTag = '';
    this.$data.currentMedia = media;
    this.$data.mediasPreview[this.currentMediaIndex] = media;
  }

  action(e: Event): void {
    this.$emit('action', e);
  }

  close(e: Event): void {
    e.preventDefault();
    e.stopPropagation();

    this.$emit('close', e);
  }

  isVideo(media: { mime_type: string; }) {
    if (!media) return false;
    const isVideo = media.mime_type?.split('/')[0] === 'video';
    return isVideo;
  }

  videoOptions(media: { mime_type: any; }, mediaIndex: any) {
    const video = this.videos.find(({ index }) => index === mediaIndex)
    if(!video) return {};
    return ({
      autoplay: false,
      controls: true,
      sources: [{
        src: video.src,
        type: media?.mime_type,
      }],
      height: 590,
    })

  }

  @Watch('medias')
  updateMedias(mediaList: [{
    id: string;
    tags: [{
      label: string;
      color?: string;
    }];
    thumb: string;
    title?: string;
    media: string | Function;
  }]): void {
    this.$data.mediasPreview = mediaList;
  }
}
